import { ChoiceCard, Container } from '@doist/marketist';
import categoryIconMapping from '../../utils/category-icon-mapping';
import css from './categories-section.module.css';
import type { PartialCategory } from '@doist/help-center-utils';
export default function CategoriesSection({
  categories
}: {
  categories: PartialCategory[];
}) {
  return <Container className={css.categoriesSection} data-sentry-element="Container" data-sentry-component="CategoriesSection" data-sentry-source-file="categories-section.tsx">
            <ul>
                {categories.map(category => <li key={category.id}>
                        <ChoiceCard icon={categoryIconMapping[category.id].icon.large} backgroundColor={categoryIconMapping[category.id].bgColor} href={category.href}>
                            {category.name}
                        </ChoiceCard>
                    </li>)}
            </ul>
        </Container>;
}